<script setup lang="ts">
import { IDeliveryDataAddress } from '@/store/delivery/delivery.types'

import { StateGeoAddress } from '@/types/mapServices'

const textOutsideDelivery = 'Вне зоны доставки'

const props = defineProps({
  checkBaloonInfo: {
    type: Boolean,
    required: true,
  },
  selectedAddress: {
    type: Object as PropType<IDeliveryDataAddress | null>,
    required: true,
  },
})

const isVisibleLoading = computed(
  () =>
    props.checkBaloonInfo &&
    props.selectedAddress?.state === StateGeoAddress.LOADING,
)

const titleAddress = computed(
  () =>
    props.selectedAddress?.address.address?.value ||
    'Не удалось определить адрес',
)
</script>

<template>
  <div v-if="!checkBaloonInfo" class="baloon__message">
    {{ textOutsideDelivery }}
  </div>

  <div v-else-if="isVisibleLoading" class="baloon__progress">
    <the-loader size="20" color="var(--ui-white)" />
  </div>

  <p v-else-if="titleAddress" class="baloon__address">
    {{ titleAddress }}
  </p>
</template>

<style lang="scss" scoped>
.baloon {
  &__progress {
    position: relative;
    width: 14px !important;
    height: 14px !important;
    margin: 0 5px 8px 0;
  }
  &__message {
    margin: 0 auto;
    font-weight: 600;
  }
  &__address {
    display: -webkit-box;
    padding-bottom: 8px;
    overflow: hidden;
    font-weight: 800;
    line-height: 14px;
    text-overflow: ellipsis;
    white-space: break-spaces;
  }
}
</style>
